import { ROUTES } from '../constants/routes/ROUTES';
import { sdGatewayClient } from '../http/sdGatewayClient';
import { Collection } from '../models/Collection';
import { OwnerReference } from '../models/OwnerReference';
import { getGuidFromHref } from '../utils/getGuidFromHref';

export const ownerReferenceService = {
  async create(unitGuidOrHref: string, notes: string) {
    const response = await sdGatewayClient.post<void>('/ownerReferences', {
      unit: {
        href: ROUTES.external.mashery.unit.externalUrlFor({ guid: getGuidFromHref(unitGuidOrHref) })
      },
      notes
    });

    return response.headers.location as string;
  },

  async getByUnit(unitGuid: string) {
    const response = await sdGatewayClient.get<Collection<OwnerReference>>(`/ownerReferences/unit/${unitGuid}`);
    return response.data.items;
  },

  async update(ownerReferenceGuid: string, notes: string) {
    if (!ownerReferenceGuid) {
      throw new Error('Cannot update notes with no href');
    }
    await sdGatewayClient.post<void>(`/ownerReferences/id/${ownerReferenceGuid}`, { notes });
  }
};
